module.exports = __webpack_public_path__ + "img/cm_promo_new.ca339286.png";